const isAuthError = (error) => {
  return error?.status && [401, 403].includes(error.status);
};

const getErrorMessage = (error, fallback = "Ett oväntat fel uppstod") => {
  if (error instanceof Response) {
    return new Promise((resolve) => {
      try {
        error
          .json()
          .then((json) => {
            resolve(json?.data || fallback);
          })
          .catch(() => {
            resolve(fallback);
          });
      } catch (error) {
        resolve(fallback);
      }
    });
  }

  const message = error.body || error.message || error;

  return typeof message === "string" ? message : fallback;
};

export { isAuthError, getErrorMessage };
